import React, { useState } from "react";
import performRequest from "../api/request";
import LoadingPage from "../Components/layouts/loading";
import { Toast } from "../CustomComponent/toast";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { StructureIcon } from "../Components/layouts/icon";
import OrderCeaKitTable from "./AgriPurchase/order_cea_kit_table";
import Footer from "../Components/Footer/footer";
import { ClientJS } from "clientjs";

function AgriPurchase() {
  const [loading, setLoading] = useState(false);
  const [table, setTable] = useState(false);
  const [length, setLength] = useState();
  const [width, setWidth] = useState();
  const [errors, setErrors] = useState({});
  const [structure, setStructure] = useState("");

  const client = new ClientJS();
  const fingerPrint = client.getFingerprint();

  const [storeFingerPrint, setStoreFingerPrint] = useState();

  useEffect(() => {
    let data = { fingerPrint };
    performRequest(
      "POST",
      "/cea-order-kit/check-cea-order-kit-user-visit",
      data
    )
      .then((res) => {
        setStoreFingerPrint(res?.data?.fingerPrint);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleQuotationSubmit = () => {
    if (!length || !width) {
      Toast("error", "Please Select Length and Width");
      return;
    }
    setTable(true);
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <>
      <Helmet>
        <title>Purchase Polyhouse, Greenhouse & Nethouse Kit | Kryzen</title>
        <meta
          name="description"
          content="Buy high-quality CEA kits including polyhouse, greenhouse, and nethouse kits. Get quotations and order directly online with Kryzen."
        />
        <meta
          name="keywords"
          content="polyhouse kit, greenhouse kit, nethouse kit, CEA kit, controlled environment agriculture kit, polyhouse quotation, greenhouse quotation, order polyhouse online, order greenhouse online"
        />

        <meta
          property="og:title"
          content="Purchase Polyhouse, Greenhouse & Nethouse Kit | Kryzen"
        />
        <meta
          property="og:description"
          content="Order CEA kits including polyhouse, greenhouse, and nethouse kits. Get quotations instantly."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://alpha.kryzen.com/order-cea-kit"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Purchase Polyhouse, Greenhouse & Nethouse Kit | Kryzen"
        />
        <meta
          name="twitter:description"
          content="Order polyhouse, greenhouse, and nethouse kits easily. Get instant quotations from Kryzen."
        />
        {/* Canonical URL */}
        <link rel="canonical" href="https://alpha.kryzen.com/order-cea-kit" />
      </Helmet>

      <div className="page">
        <div className="page-wrapper">
          <div style={{ minHeight: "80vh" }}>
            <div className="page-body">
              <div className="container-xl">
                <div className="section text-center  py-4">
                  <div className="text-center p-3 mt-2">
                    <div>
                      <div className="">
                        <div className="">
                          <div>
                            <h1
                              className="hero-title aos-init aos-animate m-0 display-5 fw-bold"
                              style={{ fontSize: "2rem" }}
                            >
                              PURCHASE POLYHOUSE / GREENHOUSE / NETHOUSE KIT
                            </h1>
                            <h2
                              className="m-0 p-0"
                              style={{ fontsize: "100px" }}
                            >
                              Invest in a complete growing solution designed for
                              modern farming.
                            </h2>
                          </div>
                          <hr></hr>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center p-3 mt-2">
                    <div>
                      <div className="">
                        <div className="">
                          <div>
                            <h1
                              className="hero-title aos-init aos-animate m-0 display-5 fw-bold"
                              style={{ fontSize: "2rem" }}
                            >
                              <StructureIcon /> SELECT YOUR STRUCTURE
                            </h1>
                            <h2
                              className="m-0 p-0"
                              style={{ fontsize: "100px" }}
                            >
                              Choose the ideal growing house for your crops —
                              Polyhouse, Greenhouse, or Nethouse.
                            </h2>

                            <div className="row col-12 mt-4 border border-1  rounded  rounded-2 p-lg-6 p-sm-2 p-2 bg-secondary-lt">
                              <div className="col-lg-4 col-sm-12 ">
                                <button
                                  className="btn btn-outline-green fs-3 fw-bold w-100 mb-3"
                                  onClick={() => setStructure("Polyhouse")}
                                >
                                  Polyhouse
                                </button>
                              </div>
                              <div className="col-lg-4 col-sm-12">
                                <button
                                  className="btn btn-outline-green fs-3 fw-bold w-100 mb-3 disabled"
                                  onClick={() => setStructure("Greenhouse")}
                                >
                                  Greenhouse
                                </button>
                              </div>
                              <div className="col-lg-4 col-sm-12">
                                <button
                                  className="btn btn-outline-green fs-3 fw-bold w-100 disabled "
                                  onClick={() => setStructure("Nethouse")}
                                >
                                  Nethouse Kit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 py-2">
                    <div className="card">
                      <div className="card-body  row d-flex">
                        <div className="mb-3  col-lg-4 col-sm-6">
                          <label className="form-label required text-start">
                            {structure} Length
                          </label>
                          <select
                            className="form-control"
                            value={length}
                            required
                            onChange={(e) => setLength(e.target.value)}
                          >
                            <option value="">Select</option>
                            {[
                              8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56,
                              60, 64, 68, 72, 76, 80, 84, 88, 92, 96, 100, 104,
                              108, 112, 116, 120, 124, 128, 132, 136, 140, 144,
                            ].map((number) => (
                              <option key={number} value={number}>
                                {number} Mtr
                              </option>
                            ))}
                          </select>
                          {errors.length && (
                            <small className="text-danger">
                              {errors.length}
                            </small>
                          )}
                        </div>

                        <div className="mb-3 col-sm-6 col-lg-4">
                          <label className="form-label required text-start">
                            {structure} Width
                          </label>
                          <select
                            className="form-control"
                            value={width}
                            onChange={(e) => setWidth(e.target.value)}
                            required
                          >
                            <option value="">Select</option>
                            {[
                              12, 20, 28, 36, 44, 52, 60, 68, 76, 84, 92, 100,
                              108, 116, 124, 132, 140, 148, 156, 164, 172, 180,
                              188, 196, 204, 212, 220, 228, 236, 244, 252, 260,
                              268, 276,
                            ].map((number) => (
                              <option key={number} value={number}>
                                {number} Mtr
                              </option>
                            ))}
                          </select>

                          {errors.width && (
                            <small className="text-danger">
                              {errors.width}
                            </small>
                          )}
                        </div>

                        <div className="col-sm-12 col-lg-4 mt-lg-5  mt-2">
                          <button
                            className="btn btn-primary"
                            onClick={handleQuotationSubmit}
                          >
                            Get Your Quotation
                          </button>
                        </div>
                      </div>
                    </div>

                    {table && (
                      <OrderCeaKitTable
                        hydrponicType={"cea-nvph"}
                        length={length}
                        width={width}
                        hydrponicPercentage={"100%"}
                        sFingerPrint={storeFingerPrint}
                        fingerPrint={fingerPrint}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
}

export default AgriPurchase;
